import { AccountGroupTypeEnum } from './types'

export * from '~/@types/ai'
export * from '~/@types/post'

export enum SystemCode {
  CHAIN_SHOP = '1', // 链作商城
  SCHOOL = '2', // 学院
  COPYRIGHT = '3', // 版权
  COVENANT = '5', // 合同
  GOLD_SHOP = '6', // 金币商城
  COPYRIGHT_SHOP = '7', // 版权文创商城
  WUJIE_AI = '8', // 无界AI
}

export const AiEquity = [
  {
    type: AccountGroupTypeEnum.ORIGIN_CARD,
    level: 0,
  },
  {
    type: AccountGroupTypeEnum.BRONZE_CARD,
    level: 1,
  },
  {
    type: AccountGroupTypeEnum.SILVER_CARD,
    level: 2,
  },
  {
    type: AccountGroupTypeEnum.GOLD_CARD,
    level: 3,
  },
  {
    type: AccountGroupTypeEnum.PLATINUM_CARD,
    level: 4,
  },
]

/** 当前用户角色 */
export enum CurrentUserRoleType {
  /** 双身份 */
  ARTIST_AND_AIARTIST = 'ARTIST_AND_AIARTIST',
  /** ai创作者 */
  AI_ARTIST = 'AI_ARTIST',
  /** 普通创作者 */
  ARTIST = 'ARTIST',
  /** 普通用户 */
  ORDINARY = 'ORDINARY',
}

export const strToBoolMap: any = {
  '1': true,
  '0': false,
}

/** 参考图 */
export const initImageMenu = [
  {
    name: '不限',
    id: '2',
  },
  {
    name: '有',
    id: '1',
  },
  {
    name: '无',
    id: '0',
  },
]

/** 是否已发布到广场 */
export const publishedToSquareMenu = [
  {
    name: '不限',
    id: '2',
  },
  {
    name: '是',
    id: '1',
  },
  {
    name: '否',
    id: '0',
  },
]

/** 是否精绘 */
export const preFineMenu = [
  {
    name: '不限',
    id: '2',
  },
  {
    name: '精绘',
    id: '1',
  },
  {
    name: '不使用精绘',
    id: '0',
  },
]

/** 是否预处理 */
export const preTreatMenu = [
  {
    name: '不限',
    id: '2',
  },
  {
    name: '需要预处理',
    id: '1',
  },
  {
    name: '不需要预处理',
    id: '0',
  },
]

// gpt描述展示状态
export enum GPTVisibleState {
  idle,
  loading,
  auto,
  error,
}

/** 无界版图-版权市场上传作品类型 */
export enum EUploadArtWorkType {
  /** ai大赛 */
  AI_COMPETITION = 'AI_COMPETITION',
  /** ai版权作品 */
  AI_COPYRIGHT = 'AI_COPYRIGHT',
  /** 版权作品 */
  COPYRIGHT = 'COPYRIGHT',
}

export enum MJQuality {
  QUALITY_025 = '.25',
  QUALITY_050 = '.5',
  QUALITY_100 = '1',
  QUALITY_200 = '2',
}

/** 对话角色 */
export enum ChatRole {
  /** 用户 */
  USER = 'user',
  /** 系统 */
  ASSISTANT = 'assistant',
}
